<template>
    <transition name="fade">
        <div ontouchmove="return false" v-if="show">
            <div class="mask_hda"></div>
            <div class="dialog_hds">
                <div class="dialog__hd">{{title}}</div>
                <template v-if="timeout===0">
                    <div class="dialog__bd">{{message}}</div>
                    <div class="dialog__ft">
                        <template v-if="isSingleButton">
                            <a href="javascript:;" class="dialog__btn dialog__btn_primary" @click="ok">{{okTxt}}</a>
                        </template>
                        <template v-else>
                            <a href="javascript:;" class="dialog__btn dialog__btn_default" @click="close">{{cancelTxt}}</a>
                            <a href="javascript:;" class="dialog__btn dialog__btn_primary" @click="ok">{{okTxt}}</a>
                        </template>
                    </div>
                </template>
                <template v-else>
                    <div class="dialog__bd">{{waitingTxt}}</div>
                    <div class="dialog__wa">
                        <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
                    </div>
                </template>
            </div>
        </div>
    </transition>

</template>
<script>
export default {
    name: 'DialogBox',
    data() {
        return {
            show: false,
            title: '提示',
            message: '',
            waitingMessage: '',
            isSingleButton: false,
            okTxt: '确定',
            cancelTxt: '取消',
            waitingFn: null,
            waitingOver: null,
            resolve: null,
            reject: null,
            timeout: 0,
            timer: null,
        }
    },
    computed: {
        waitingTxt() {
            return this.waitingMessage.replace('#', this.timeout)
        }
    },
    methods: {
        close() {
            this.show = false
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
            this.resolve('cancel')
        },
        ok() {
            this.show = false
            this.resolve('ok')
        },

    }
}
</script>
<style scoped>
.mask_hda {
  position: fixed;
  z-index: 18;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}
.dialog_hds {
  position: fixed;
  z-index: 5000;
  width: 280px;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  text-align: center;
  border-radius: 4px;
  overflow: hidden;
}
.dialog__hd {
  padding-top: 29px;
  font-size: 18px;
  color: #000;
  text-align: center;
  font-weight: bold;
}
.dialog__bd {
  padding: 0 25px;
  min-height: 60px;
  font-size: 15px;
  word-wrap: break-word;
  word-break: break-all;
  color: #999;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
}
.dialog__ft {
  position: relative;
  line-height: 50px;
  font-size: 18px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.dialog__wa img {
    width: 30px;
    height: 30px;
    display: block;
    margin: 5px auto 15px;
}
.dialog__btn {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #09bb07;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
}
.dialog__btn_default {
  color: #333;
}
.dialog__btn_primary {
  color: #18b86e;
}
.dialog__btn:after {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-left: 1px solid #d5d5d6;
  color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.dialog__btn:first-child:after {
  border-left: 0;
}
.dialog__ft:after {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 1px solid #d5d5d6;
  color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/plugins/Dialog/Dialog.vue